import React from 'react';
import { Input } from 'antd';
import { DateTimePicker } from 'react-rainbow-components';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { useHybridMail } from './HybridMailContext';
import { DEFAULT_DATE_TIME_FORMAT } from '../../../../utils/helper';
import { MAIL_ROOM_DOCUMENT_FILTERS } from '../../../MailRoom/translationValues';
import { Filters, DateRangeFilter, PageFilter } from './HybridMailStyles';

const NAMESPACES=['MAIL_ROOM_DOCUMENT_FILTERS']

const { Search } = Input;

const HybridQueueFilters = ({ t }) => {
  const {
    qSearchValue,
    setQSearchValue,
    qSearchByDocName,
    setQSearchByDocName,
    qStartAndEndDate,
    setQStartAndEndDate,
    qPageFilter,
    setQPageFilter
  } = useHybridMail();


  return (
    <Filters>
      <div className="searchDoc">
        <Search
          placeholder={t(MAIL_ROOM_DOCUMENT_FILTERS.SEARCH_DOCUMENT_PLACEHOLDER.key, MAIL_ROOM_DOCUMENT_FILTERS.SEARCH_DOCUMENT_PLACEHOLDER.value)}
          onPressEnter={() => setQSearchByDocName(qSearchValue)}
          onSearch={() => setQSearchByDocName(qSearchValue)}
          allowClear
          style={{ width: 200 }}
          value={qSearchValue}
          onChange={e => {
            setQSearchValue(e.target.value);
            e.target.value.length === 0 && setQSearchByDocName(null);
          }}
        />
      </div>
      <PageFilter>
      <DateRangeFilter>
        <DateTimePicker
          label={t(MAIL_ROOM_DOCUMENT_FILTERS.DATE_TIME_PICKER_FROM_LABEL.key, MAIL_ROOM_DOCUMENT_FILTERS.DATE_TIME_PICKER_FROM_LABEL.value)}
          minDate={new Date(2026, 0, 1)}
          maxDate={new Date()}
          className="dateTimePicker"
          formatStyle="large"
          size="small"
          onChange={value =>
            setQStartAndEndDate(prevState => ({
              ...prevState,
              startDate: moment(value).format(DEFAULT_DATE_TIME_FORMAT),
            }))
          }
          hour24
          value={qStartAndEndDate.startDate}
          isCentered
        />
        <DateTimePicker
           label={t(MAIL_ROOM_DOCUMENT_FILTERS.DATE_TIME_PICKER_TO_LABEL.key, MAIL_ROOM_DOCUMENT_FILTERS.DATE_TIME_PICKER_TO_LABEL.value)}
          minDate={new Date(2026, 0, 1)}
          maxDate={new Date()}
          className="dateTimePicker"
          formatStyle="large"
          size="small"
          onChange={value =>
            setQStartAndEndDate(prevState => ({
              ...prevState,
              endDate: moment(value).format(DEFAULT_DATE_TIME_FORMAT),
            }))
          }
          hour24
          value={qStartAndEndDate.endDate}
          isCentered
        />
      </DateRangeFilter>
      </PageFilter>
    </Filters>
  );
};

export default withTranslation(NAMESPACES)(HybridQueueFilters);
